<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Assign Accounting Connection</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p>
      The selected locations will use <b>{{ conn.name }}</b> for revenue reporting. Each location may only be assigned to one connection, so if a selected location already has a connection, it will be reassigned to this one.
    </p>

    <div class="form-group">
      <label class="mb-1">Locations</label>

      <label *ngIf="loadingLocations" class="form-text text-muted">Loading...</label>

      <div class="form-check ml-3" *ngFor="let location of locations">
        <input class="form-check-input" type="checkbox"
               [id]="'location-' + location.id.toString()"
               [checked]="selectedLocationIds.includes(location.id)"
               (change)="toggleLocationId(location.id)">
        <label class="form-check-label" [for]="'location-' + location.id.toString()">
          {{ location.name }}:
          <span *ngIf="location.accounting_connection_name !== null">
            <b>Currently assigned to {{ location.accounting_connection_name }}</b>
          </span>
          <span *ngIf="location.accounting_connection_name === null" class="text-muted">
            No Accounting Connection
          </span>
        </label>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            (click)="handleSubmit()"
            *ngIf="!(loadingSave || loadingLocations)">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave || loadingLocations">
      Loading...
    </button>
  </div>

</ng-container>
